export default () => {
  self.onmessage = ({ data }) => {
    setInterval(() => {
      postMessage(data);
    }, 1000);
  };
};
